module.exports = __webpack_public_path__ + "static/media/ic_nav_04.d3b22976.svg";